<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6 text-center">
                <img src="/static/assets/images/ico-estatisticas.svg" alt="icone estatísticas">
                <!-- <p>Na IOUU, adoramos dados, por isso fornecemos alguns fatos e números interessantes sobre nossos investidores e empréstimos para você explorar.</p> -->
                <p>As estatísticas da plataforma fornecem informações importantes sobre investimentos e empréstimos para você explorar.</p>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-8 text-center">
                <ul>
                    <li>
                        <router-link to="/investimentos/estatisticas/estatisticas-da-plataforma/investidores">Desempenho dos investidores</router-link>
                    </li>
                    <li>
                        <router-link to="/investimentos/estatisticas/estatisticas-da-plataforma/emprestimos">Estatísticas de empréstimos</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <router-view  />
    </div>
</template>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    img {
        width: 110px;
        margin-top: 50px;
    }
    p {
        @include font-size(21px);
        @include line-height(25px);
        color: #999999;
        padding:0px;
        margin:35px 0;
    }
    ul {
        padding:0px;
        margin:20px 0 70px 0;
        li {
            display: inline-block;
            margin: 0 12px;

            a {
                @include font-size(18px);
                color: #999;
                font-weight: bold;

                &.router-link-active {
                    color: #999;

                    &:hover {
                        color: #000;
                    }
                }

                &.router-link-exact-active {
                    color: #000;
                    
                    @include separador(100%, 3px, 10px, 0px, 0, auto, $c3);
                }
            }
        }
    }

    // DESKTOP
    @include ds {
        img {
            width: 80px;
            margin-top: 30px;
        }

        p {
            @include font-size(16px);
            @include line-height(20px);
        }

        ul {
            margin:10px 0 30px 0;

            li {
                a {
                    @include font-size(14px);
                }
            }
        }
    }
</style>
<script>
export default {
    methods: {
        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/estatisticas/estatisticas-da-plataforma',
                title: 'Estatisticas da plataforma',
            })
        },
    },
    beforeCreate(){
        this.$store.dispatch('updateUser')
    },
    async created(){
        if(this.$store.state.currentUser.investor != null){
            if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined')
                window.location.href="#/"
        }
        //tagueamento GA
        await this.taggingGA();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/StatisticsPlatform.vue